/**
 * 模板配置 i18n 后处理
 * 当语言为非中文时，将 extras 中的 _en 后缀 key 覆盖到主 key
 * 例如：extras.contact_en -> extras.contact, extras.content_en -> extras.content
 * 同时处理 value 对象内部的 _en 后缀字段（如 text_en -> text）
 */
import langManager from "../model/lang";

var SUFFIX_MAP = {
  "en-US": "_en",
  en_US: "_en",
  "zh-TW": "_tw",
  zh_TW: "_tw",
};

/**
 * 对 extras 对象做语言后处理
 */
export function applyI18nExtras(extras) {
  console.log("[i18n-extras] current lang:", langManager.current);
  if (!extras || langManager.current === "zh_CN") {
    console.log("[i18n-extras] skip: zh_CN or no extras");
    return extras;
  }
  var suffix = SUFFIX_MAP[langManager.current];
  if (!suffix) {
    return extras;
  }

  // 第一步：收集所有 _en 后缀的 key
  var i18nKeys = {};
  var allKeys = Object.keys(extras);
  for (var i = 0; i < allKeys.length; i++) {
    var key = allKeys[i];
    if (
      key.indexOf(suffix) === key.length - suffix.length &&
      key.length > suffix.length
    ) {
      var baseKey = key.substring(0, key.length - suffix.length);
      i18nKeys[baseKey] = key;
    }
  }

  // 第二步：构建结果，用 _en 版本覆盖主 key
  var result = {};
  for (var j = 0; j < allKeys.length; j++) {
    var k = allKeys[j];
    // 跳过 _en 后缀的 key 本身（如 contact_en）
    if (
      k.indexOf(suffix) === k.length - suffix.length &&
      k.length > suffix.length
    ) {
      continue;
    }
    // 如果有对应的 _en 版本，合并（_en 覆盖内容字段，但保留控制字段如 display）
    if (i18nKeys[k] && extras[i18nKeys[k]]) {
      var base = extras[k] || {};
      var i18n = extras[i18nKeys[k]];
      // 控制字段：不应被翻译版本覆盖
      var CONTROL_FIELDS = {
        display: 1,
        layout: 1,
        style: 1,
        type: 1,
        order: 1,
        colorOrBg: 1,
        src: 1,
        btnWidth: 1,
      };
      var merged = {};
      // 先复制 base 所有字段
      var baseKeys = Object.keys(base);
      for (var bi = 0; bi < baseKeys.length; bi++) {
        merged[baseKeys[bi]] = base[baseKeys[bi]];
      }
      // 用 _en 版本覆盖，但跳过控制字段
      var i18nKeys2 = Object.keys(i18n);
      for (var ii = 0; ii < i18nKeys2.length; ii++) {
        if (!CONTROL_FIELDS[i18nKeys2[ii]]) {
          merged[i18nKeys2[ii]] = i18n[i18nKeys2[ii]];
        }
      }
      result[k] = merged;
    } else {
      result[k] = extras[k];
    }
  }

  // 第三步：对每个 value 对象内部也做 _en 后缀处理
  var finalResult = {};
  var resultKeys = Object.keys(result);
  for (var m = 0; m < resultKeys.length; m++) {
    var rk = resultKeys[m];
    var rv = result[rk];
    if (rv && typeof rv === "object" && !Array.isArray(rv)) {
      finalResult[rk] = applyI18nValue(rv, suffix);
    } else {
      finalResult[rk] = rv;
    }
  }

  console.log(
    "[i18n-extras] processed, signUpText:",
    finalResult.signUpText
      ? {
          display: finalResult.signUpText.display,
          model: finalResult.signUpText.model,
        }
      : "N/A"
  );
  return finalResult;
}

/**
 * 对单个 value 对象做语言后处理
 * 如果存在 key_en 字段，覆盖 key 字段
 */
function applyI18nValue(obj, suffix) {
  var result = {};
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    // 跳过已有的 _en/_tw 后缀字段
    if (
      key.indexOf("_en") === key.length - 3 ||
      key.indexOf("_tw") === key.length - 3
    ) {
      continue;
    }
    result[key] = obj[key];
    // 检查是否有对应语言后缀的字段
    var i18nKey = key + suffix;
    if (
      Object.prototype.hasOwnProperty.call(obj, i18nKey) &&
      obj[i18nKey] !== undefined &&
      obj[i18nKey] !== ""
    ) {
      result[key] = obj[i18nKey];
    }
  }
  return result;
}
